import {
  Component,
  ComponentRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CardModelType } from '../../common/custom.types';
import { ActionBtnInfo, CardContentWithBtnInfo, EntityStatus, ItemStatus } from '../../interfaces/views.interface';
import { BasicCardComponent } from './basic-card/basic-card.component';
import { CardDirective } from './card.directive';
import { CardDirector } from './card.director';
import { CardType, InviteCardType } from './cards.types';
import { cardDeleted } from './cards.value';

@Component({
  selector: 'app-card',
  template: '<ng-template card-host></ng-template>',
})
export class CardParent implements OnInit, OnChanges {
  @Input({ required: true }) public data: CardModelType;
  @Input({ required: true }) public index: number;
  @Input({ required: true }) public type: CardType | InviteCardType;

  @Input({ required: false }) public status: EntityStatus = ItemStatus.EMPTY;
  @Input({ required: false }) public redirectToLoginIfNoSession: boolean;
  @Input({ required: false }) public actionDisabled: boolean;
  @Input({ required: false }) public actionBtnHint: string;

  @Output() private action: EventEmitter<ActionBtnInfo> = new EventEmitter<ActionBtnInfo>();

  @ViewChild(CardDirective, { static: true }) public cardHost: CardDirective;

  private cardDirector = inject(CardDirector);

  public ngOnInit(): void {
    this.initComponent();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('type' in changes && changes['type'].firstChange) {
      return;
    }

    if (this.cardHost.viewContainerRef.length > 0) {
      this.cardHost.viewContainerRef.clear();
    }

    this.initComponent();
  }

  private initComponent(): void {
    const component: ComponentRef<CardContentWithBtnInfo> =
      this.cardHost.viewContainerRef.createComponent(BasicCardComponent);

    const cardData = this.status === ItemStatus.DELETED ? cardDeleted : this.data;

    component.instance.card = this.cardDirector.getCard(
      cardData,
      this.type,
      this.status,
      this.redirectToLoginIfNoSession,
      this.actionBtnHint,
    );

    component.instance.index = this.index;
    component.instance.status = this.status;
    component.instance.actionDisabled = this.actionDisabled;

    component.instance.action.subscribe((btnInfo: ActionBtnInfo) => {
      this.action.emit(btnInfo);
    });
  }
}
